<template>
  <div>
    <b-navbar
      toggleable="lg"
      :sticky="true"
      class="header"
    >
      <b-navbar-brand
        href="/"
        class="d-flex flex-column"
      >
        <span class="headline">LGBT総合イベントサイト</span>
        <img
          src="/assets/img/logo.svg"
          alt="ColorsJP logo"
          width="140"
          class="main-logo"
        >
      </b-navbar-brand>

      <b-navbar-toggle target="nav-collapse" />

      <b-collapse
        id="nav-collapse"
        is-nav
      >
        <b-navbar-nav class="left">
          <b-nav-item :to="{ name: 'events' }">
            あなたのイベント一覧
          </b-nav-item>
          <b-nav-item :to="{ name: 'communities' }">
            あなたのコミュニティ一覧
          </b-nav-item>
        </b-navbar-nav>

        <b-navbar-nav class="ml-auto right">
          <b-nav-item
            :href="colorsWebUrl"
            target="_blank"
          >
            <b-icon icon="calendar2-date" />
            Colors Japanへ戻る
          </b-nav-item>
          <b-nav-item-dropdown
            v-if="userProfile"
            right
          >
            <template v-slot:button-content>
              <b-icon-person-square class="mr-1" />
              <span>{{ userProfile.firstName }}、こんにちは！</span>
            </template>
            <b-dropdown-item :to="{ name: 'account' }">
              アカウント
            </b-dropdown-item>
            <b-dropdown-item @click="logout()">
              ログアウト
            </b-dropdown-item>
          </b-nav-item-dropdown>
          <b-nav-item
            v-else-if="userProfileStatus !== 'loading'"
            :to="{ name: 'login' }"
          >
            <b-icon-person-circle class="mr-1" />
            <span>Login/Register</span>
          </b-nav-item>
          <b-nav-item v-if="userProfileStatus === 'loading'">
            <b-icon
              icon="arrow-clockwise"
              animation="spin-pulse"
              font-scale="1"
            />
          </b-nav-item>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </div>
</template>

<style lang="less" scoped>
.header {
  background: #fff;
  box-shadow: 0 0 8px #bbb;
  font-size: 16px;

  .navbar-nav {
    .nav-item {
      font-size: 16px;
      .nav-link {
        color: #d5347a;
      }
    }
    &.left {
      .nav-link {
        &:hover {
          border-bottom: 1px solid #d5347a;
        }
      }
      .router-link-active {
        border-bottom: 1px solid #d5347a;
      }
    }
    &.right {
      .nav-link {
        transition: .4s color;
        color: #d5347a;
        &:hover {
          color: #992762;

          span, svg {
            transition: .4s color;
            color: #992762;
          }
        }
        span, svg {
          color: #d5347a;
        }
      }
    }
  }
}

@media only screen and (max-width: 576px) {
  .main-logo {
    width: 100px;
  }
}

.header-social a {
  font-size: 24px !important;
}

.headline {
  font-size: 12px;
  color: #232323;
}
</style>

<script>
import { AUTH_LOGOUT, FEATURE_REQUEST } from "@/store/constant";
import { mapGetters } from "vuex";

export default {
  name: 'Header',
  data() {
    return {
      user: null,
      showMenu: false,
      colorsWebUrl: process.env.VUE_APP_COLORSJP_WEB_URL,
    }
  },
  computed: {
    ...mapGetters(['userProfile', 'userProfileStatus'])
  },
  mounted() {
    this.getFeatures();
  },
  methods: {
    logout() {
      this.$store.dispatch(AUTH_LOGOUT)
        .then(() => {
          if(this.$route.path !== '/') {
            this.$router.push({ name: 'login' });
          }
        })
    },
    menuToggle() {
      this.showMenu = !this.showMenu;
    },
    getFeatures() {
      this.$store.dispatch(FEATURE_REQUEST);
    }
  }
}
</script>
